import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/utils";
import { AUTOSAVE_IDLE_MS, Spinner } from "@cohesive/ui-components";
import { useHtmlInlineEditState } from "./HtmlInlineEditContext";

/**
 * Header status for HTML island autosave: pending edit count and in-flight
 * save spinner. Rendered beside the publish control in the file-record pane.
 */
export function HtmlAutosaveIndicator() {
  const { pendingCount, isSaving } = useHtmlInlineEditState();

  if (pendingCount === 0 && !isSaving) {
    return null;
  }

  const pendingLabel =
    pendingCount === 1 ? "1 unsaved change" : `${pendingCount} unsaved changes`;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              "inline-flex items-center gap-1.5 shrink-0 text-xs text-muted-foreground tabular-nums pr-1",
            )}
            aria-live="polite"
          >
            {isSaving && <Spinner size="sm" aria-hidden />}
            {pendingCount > 0 && <span>{pendingLabel}</span>}
            {pendingCount === 0 && isSaving && <span>Saving…</span>}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          Edits autosave after {AUTOSAVE_IDLE_MS / 1000}s of inactivity. Use
          Cmd+S to save immediately.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
